(() => {
  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
  const DOT_SELECTOR = [
    'button[class*="dot"]',
    '[role="tab"][class*="dot"]',
    '.slider-counter__link',
  ].join(',');
  const ACTIVE_SELECTOR = [
    '.active',
    '[aria-current="true"]',
    '[aria-selected="true"]',
    '[aria-pressed="true"]',
    '.slider-counter__link--active',
  ].join(',');

  let gesture = null;

  function findCarousel(start) {
    let node = start instanceof Element ? start : start?.parentElement;

    while (node && node !== document.body) {
      const className = typeof node.className === 'string' ? node.className : '';
      const looksLikeCarousel =
        /carousel|testimonial|slideshow|slider/i.test(className) ||
        /^(SLIDESHOW-COMPONENT|SLIDER-COMPONENT)$/.test(node.tagName);
      const dots = looksLikeCarousel ? [...node.querySelectorAll(DOT_SELECTOR)] : [];

      if (dots.length > 1) return { node, dots };
      node = node.parentElement;
    }

    return null;
  }

  function activeDotIndex(dots) {
    const activeIndex = dots.findIndex((dot) => dot.matches(ACTIVE_SELECTOR));
    if (activeIndex >= 0) return activeIndex;

    return dots.findIndex((dot) => dot.tabIndex === 0);
  }

  document.addEventListener(
    'touchstart',
    (event) => {
      if (!MOBILE_QUERY.matches || event.touches.length !== 1) return;
      if (event.target.closest('button, input, textarea, select, video, iframe')) return;

      const carousel = findCarousel(event.target);
      if (!carousel) return;

      const touch = event.touches[0];
      gesture = {
        carousel,
        x: touch.clientX,
        y: touch.clientY,
      };
    },
    { passive: true },
  );

  document.addEventListener(
    'touchend',
    (event) => {
      if (!gesture || event.changedTouches.length !== 1) {
        gesture = null;
        return;
      }

      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - gesture.x;
      const deltaY = touch.clientY - gesture.y;
      const { dots } = gesture.carousel;
      gesture = null;

      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY) * 1.25) return;

      const currentIndex = activeDotIndex(dots);
      if (currentIndex < 0) return;

      const direction = deltaX < 0 ? 1 : -1;
      const nextIndex = (currentIndex + direction + dots.length) % dots.length;
      dots[nextIndex].click();
    },
    { passive: true },
  );

  document.addEventListener('touchcancel', () => {
    gesture = null;
  });
})();
